(() => {
  const formatMoney = (cents, format) => {
    const value = (cents / 100).toFixed(2);
    return (format || '${{amount}}')
      .replace('{{amount}}', value)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
      .replace('{{amount_with_comma_separator}}', value.replace('.', ','));
  };

  document.querySelectorAll('[data-localization-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  const catalogUrl = new URL(window.location.href);
  if (catalogUrl.pathname === '/collections/all' && !catalogUrl.searchParams.has('sort_by')) {
    catalogUrl.searchParams.set('sort_by', 'best-selling');
    window.location.replace(catalogUrl.toString());
    return;
  }

  document.querySelectorAll('.product-gallery__thumb').forEach((button) => {
    button.addEventListener('click', () => {
      const main = button.closest('.product-gallery')?.querySelector('[data-product-media-main] img');
      if (!main) return;
      main.src = button.dataset.mediaSrc || main.src;
      main.alt = button.dataset.mediaAlt || main.alt;
      button.parentElement?.querySelectorAll('.product-gallery__thumb').forEach((thumb) => thumb.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const variantsNode = section.querySelector('[data-product-variants]');
    const form = section.querySelector('[data-product-form]');
    if (!variantsNode || !form) return;

    let variants = [];
    try { variants = JSON.parse(variantsNode.textContent || '[]'); } catch (_) { return; }

    const addButton = form.querySelector('[data-add-to-cart]');
    const directForm = section.querySelector('[data-direct-checkout-form]');
    const directVariantInput = directForm?.querySelector('input[name="id"]');
    const stickyBar = section.querySelector('[data-sticky-buy]');
    const stickyButton = stickyBar?.querySelector('[data-sticky-add]');
    const stickyText = stickyBar?.querySelector('[data-sticky-add-text]');
    const stickyPrice = stickyBar?.querySelector('[data-sticky-price]');

    const updateVariant = () => {
      const selectedOptions = [...form.querySelectorAll('[data-option-input]:checked')].map((input) => input.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === selectedOptions[index])) || variants[0];
      if (!variant) return;

      const idInput = form.querySelector('[data-variant-id]');
      const addText = form.querySelector('[data-add-to-cart-text]');
      if (idInput) idInput.value = variant.id;
      if (directVariantInput) directVariantInput.value = variant.id;
      if (addButton) addButton.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? window.jalisiStrings?.addToCart || 'Add to cart' : window.jalisiStrings?.soldOut || 'Sold out';
      if (stickyButton) stickyButton.disabled = !variant.available;
      if (stickyText) stickyText.textContent = variant.available ? 'اطلب الآن' : window.jalisiStrings?.soldOut || 'نفد المخزون';

      const priceTarget = section.querySelector('[data-product-price]');
      if (priceTarget || stickyPrice) {
        const moneyFormat = document.documentElement.dataset.moneyFormat || '${{amount}}';
        const compare = variant.compare_at_price && variant.compare_at_price > variant.price ? `<s class="price__compare">${formatMoney(variant.compare_at_price, moneyFormat)}</s>` : '';
        const priceHtml = `<div class="price"><span class="price__current">${formatMoney(variant.price, moneyFormat)}</span>${compare}</div>`;
        if (priceTarget) priceTarget.innerHTML = priceHtml;
        if (stickyPrice) stickyPrice.innerHTML = priceHtml;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    form.querySelectorAll('[data-option-input]').forEach((input) => input.addEventListener('change', updateVariant));

    stickyButton?.addEventListener('click', () => {
      if (stickyButton.disabled) return;
      if (directForm && typeof directForm.requestSubmit === 'function') directForm.requestSubmit();
      else if (typeof form.requestSubmit === 'function') form.requestSubmit(addButton || undefined);
      else addButton?.click();
    });

    if (stickyBar && addButton) {
      const setStickyVisibility = () => {
        const buttonPosition = addButton.getBoundingClientRect();
        stickyBar.hidden = buttonPosition.bottom >= 0 || buttonPosition.top > window.innerHeight;
      };

      if ('IntersectionObserver' in window) {
        const stickyObserver = new IntersectionObserver(([entry]) => {
          stickyBar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        });
        stickyObserver.observe(addButton);
      } else {
        window.addEventListener('scroll', setStickyVisibility, { passive: true });
        setStickyVisibility();
      }
    }
  });

  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    reveals.forEach((element) => observer.observe(element));
    window.setTimeout(() => reveals.forEach((element) => element.classList.add('is-visible')), 1800);
  } else {
    reveals.forEach((element) => element.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-open-localization]').forEach((button) => {
    button.addEventListener('click', () => {
      const localization = document.querySelector('.localization');
      if (!localization) return;
      localization.open = true;
      localization.querySelector('select[name="country_code"]')?.focus();
    });
  });

  document.addEventListener('click', (event) => {
    const videoTrigger = event.target.closest('[data-video-review-trigger]');
    if (videoTrigger) {
      const wrapper = videoTrigger.closest('[data-video-review]');
      const player = wrapper?.querySelector('[data-video-review-player]');

      if (player) {
        if (!player.dataset.loaded) {
          const sources = [
            { src: player.dataset.hlsSrc, type: 'application/x-mpegURL' },
            { src: player.dataset.mp4Src, type: 'video/mp4' }
          ];

          sources.forEach(({ src, type }) => {
            if (!src) return;
            const source = document.createElement('source');
            source.src = src;
            source.type = type;
            player.appendChild(source);
          });

          player.dataset.loaded = 'true';
          player.load();
        }

        videoTrigger.hidden = true;
        player.hidden = false;
        player.play().catch(() => {});
      }
    }

    document.querySelectorAll('.header-actions details[open], .desktop-menu-dropdown[open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.header-actions details[open], .desktop-menu-dropdown[open], .mobile-menu[open]').forEach((details) => details.removeAttribute('open'));
  });
})();
